import React, { useState } from 'react';
import banyanLogo from '../assets/banyan-logo.png';

/**
 * Firm logo on a report, pinned to the top-right corner. Rendered only when the
 * report window's "firm logo" toggle is on. Decorative (the firm name is already
 * in the header strip), and it removes itself if the bundled asset ever fails to
 * load so a swapped-in but broken file degrades to nothing rather than a
 * broken-image icon.
 */
const ReportLogo = () => {
  const [failed, setFailed] = useState(false);
  if (failed) return null;
  return (
    <div className="flex justify-end">
      <img
        src={banyanLogo}
        alt=""
        data-testid="report-logo"
        className="h-14 w-auto object-contain"
        onError={() => setFailed(true)}
      />
    </div>
  );
};

export default ReportLogo;
